import { render, staticRenderFns } from "./WarningBlock.vue?vue&type=template&id=52c01d14&scoped=true&"
import script from "./WarningBlock.vue?vue&type=script&lang=ts&"
export * from "./WarningBlock.vue?vue&type=script&lang=ts&"
import style0 from "./WarningBlock.vue?vue&type=style&index=0&id=52c01d14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c01d14",
  null
  
)

export default component.exports